import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm, NgModel } from "@angular/forms";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { MessageService } from "primeng/components/common/messageservice";
import { ApprovalClassModel } from "../../../../../components/googleClassroom/googleClassroom.model";
import { AddStudentRcModel,rciModel } from "../../../../../components/dataAnalytics/dataAnalytics.model";
import { AppConstants } from "../../../../../app.constants";
import * as html2pdf from "html2pdf.js";
import { Router } from "@angular/router";
import { style } from "@angular/core/src/animation/dsl";
declare var gapi: any;

@Component({
  selector: "digital-report-card2Q",
  templateUrl: "digital-report-card2Q.component.html",
  styleUrls: ["digital-report-card2Q.component.scss"],
})
export class DigitalReportCardQComponent2 implements OnInit {
  @ViewChild("form") form: NgForm;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel();
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearId: any = [];
  yearname: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none";
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress: any = [];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = [];
  guru: any = [];
  payload: any = [];
  public isEditable: Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName: any;
  public schoolLogo1: string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City: any;
  public Pincode: any;
  public PrimaryPhonenumber: any;
  public WebsiteLink: any;
  public Email: any;
  public Logo: any;
  public RegNo: any;
  public userId: string;
  public childMapId: any = [];
  public TeacherNames: any = [];
  public EncodedLogo: any;

  public HigherEdchildcourse: any;
  public selectedCourse: string = "";
  public HigherEdchildbatch: any;
  public selectedBatch: string = "";
  public HigherEdchildinfo: any;
  public selectedinfo: string = "";
  public HigherEdchildsemester: any;
  public selectedSemester: string = "";
  public HigherEdchildexam: any;
  public selectedExam: string = "";
  public HigherEdDRC: any;
  public selectedDRC: string = "";

  public OverallComments: string = "Null";


  constructor(
    private dataAnalyticsService: DataAnalyticsService,
    private router: Router,
    private noticeboardService: NoticeboardService,
    private appConstants: AppConstants,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {
    // this.schoolName = this.localStorage.retrieve('schoolname');
    this.schoolLogo1 = this.localStorage.retrieve("Logo");
    this.imgUrl1 = this.appConstants.fileDownloadUrl;
    // this.attachment = this.imgUrl1 + this.Logo;
    this.userId = this.localStorage.retrieve("id");
  }

  ngOnInit() {
    this.adminUserFlag = this.localStorage.retrieve("IsSchoolAdminUser");
    this.schoolUserFlag = this.localStorage.retrieve("Isschooluser");
    this.GetCourseList();
    if (this.adminUserFlag || this.schoolUserFlag) {
      this.getClassSection();
    } else {
    }

    if (this.adminUserFlag == true) {
      this.schoolUserFlag = false;
    }
    this.getYearData();
  }

  //----------------------------------------------------------------------------------------------

  private GetCourseList() {
    this.dataAnalyticsService
      .getHigherEdChildCourseList()
      .finally(() => {})
      .subscribe(
        (response) => {
          this.HigherEdchildcourse = response["items"];
          try {
            this.selectedCourse = this.HigherEdchildcourse[0].CourseId;
            this.getHigherEdChildBatch();
            this.GetStudentDRC();
          } catch (error) {}
          console.log("HigherEdchildcourse", this.HigherEdchildcourse);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  changecourse() {
    console.log("courseT", this.selectedCourse);
    this.getHigherEdChildBatch();
  }

  //----------------------------------------------------------------------------------------------------------
  private getHigherEdChildBatch() {
    this.dataAnalyticsService
      .getHigherEdChildBatchList(this.selectedCourse)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.HigherEdchildbatch = response["Value"];
          try {
            this.selectedBatch = this.HigherEdchildbatch[0].Id;
            this.HigherEdChildinfo();
            this.GetStudentDRC();
          } catch (error) {}
          console.log("HigherEdchildbatch", this.HigherEdchildbatch);
        },
        (error) => {
          this.HigherEdchildbatch = [];
          console.error(error);
        }
      );
  }

  changebatch() {
    console.log("batch", this.selectedBatch);
    this.HigherEdChildinfo();
  }

  //----------------------------------------------------------------------------------------------------------
  private HigherEdChildinfo() {
    this.dataAnalyticsService
      .getHiEduChildInfo(this.selectedCourse, this.selectedBatch)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.HigherEdchildinfo = response;
          try {
            this.selectedinfo = this.HigherEdchildinfo[0].ChildId;
            this.GetSemesterList();
            this.GetStudentDRC();
          } catch (error) {}
          console.log("HigherEdchildinfo", this.HigherEdchildinfo);
        },
        (error) => {
          this.HigherEdchildinfo = [];
          console.error(error);
        }
      );
  }

  changeChildInfo() {
    console.log("ChildInfo", this.selectedinfo);
    this.GetSemesterList();
  }
  //----------------------------------------------------------------------------------------------------------

  private GetSemesterList() {
    this.dataAnalyticsService
      .getHigherEdChildSemesterList(this.selectedCourse)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.HigherEdchildsemester = response;
          try {
            this.selectedSemester = this.HigherEdchildsemester[0].Id;
            this.GetExamsList();
            this.GetStudentDRC();
          } catch (error) {}
          console.log("HigherEdchildsemester", this.HigherEdchildsemester);
        },
        (error) => {
          this.HigherEdchildsemester = [];
          console.error(error);
        }
      );
  }

  changesemester() {
    console.log("semester", this.selectedSemester);
    this.GetExamsList();
  }

  //----------------------------------------------------------------------------------------------------------

  private GetExamsList() {
    this.dataAnalyticsService
      .getHigherEdChildExamList(this.selectedCourse, this.selectedSemester)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.HigherEdchildexam = response["Value"];
          try {
            this.selectedExam = this.HigherEdchildexam[0].examid;
            this.GetStudentDRC();
          } catch (error) {}
          console.log("HigherEdchildexam", this.HigherEdchildexam);
        },
        (error) => {
          this.HigherEdchildexam = [];
          console.error(error);
        }
      );
  }

  changeexam() {
    console.log("semester", this.selectedExam);
    this.GetStudentDRC();
  }
  //----------------------------------------------------------------------------------------------------------
  private GetStudentDRC() {
    this.dataAnalyticsService
      .getHiEduChildDRC(
        this.selectedCourse,
        this.selectedBatch,
        this.selectedinfo,
        this.selectedSemester,
        this.selectedExam
      )
      .finally(() => {})
      .subscribe(
        (response) => {
          this.HigherEdDRC = response[0]["HiEduStudentRCInnerModels"];

          this.HigherEdDRC.forEach((element) => {
            /*element.SubSubjectMaxMarks = Array.from({ length: element.SubSubjects.length }, () => 70);*/
            //element.SubSubjectAbsent = Array.from({ length: element.SubSubjects.length }, () => 0);
            /*element.SubSubjectWeight = Array.from({ length: element.SubSubjects.length }, () => 50);*/
          });

          this.calculatePercentagesOnTheFly();
          console.log("HigherEdDRC", this.HigherEdDRC);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  changedrc() {
    console.log("semester", this.selectedDRC);
  }

  //----------------------------------------------------------------------------------------------------------

  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve("Id");
    this.noticeboardService.getUserdetailbyId(id).subscribe((response) => {
      this.userdetailes = response["selectedSbAccessPermission"];
      const isAdmin = this.userdetailes.some((u) => u.Rank == 1);

      let result = this.mappedData.filter((m) =>
        this.userdetailes.some(
          (u) => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        )
      );
      const sectionsResult = this.mappedData
        .filter((m) =>
          this.userdetailes.some(
            (u) =>
              !result.some((r) => r.standardId === u.standardid) &&
              u.Rank == 4 &&
              m.Sections.some((s) => s.SectionId === u.sectionid)
          )
        )
        .map((m) => ({
          ...m,
          Sections: m.Sections.filter((s) =>
            this.userdetailes.some((u) => u.sectionid === s.SectionId)
          ),
        }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, "result");
    });
  }

  PrintPdf() {
    // this.schoolLogo1 = this.EncodedLogo;
    // console.log(this.schoolLogo1 )
    this.previwbtn = true;
    this.printbtn = false;
    const options = {
      filename: this.nameofstudent,
      margin: [15, 0, 15, 0],
      image: { type: "jpeg", quality: 1 },
      // html2canvas : {},
      layout: "noBorders",
      html2canvas: {
        dpi: 192,
        scale: 4,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: {
        orientation: "portrait",
        unit: "pt",
        format: "a4",
        compressPDF: false,
      },
    };

    const content: Element = document.getElementById("asdf");

    html2pdf().from(content).set(options).save();
  }

  edit() {
    this.isEditable = false;
  }

  discard() {
    this.isEditable = true;
    this.GetStudentDRC();
    //this.getStudentRecord(this.studentId,this.testId,this.yearId);
    //this.getAveragePerformances(this.sectionId,this.testId,this.studentId,this.yearId);
  }

  back() {
    this.previwbtn = true;
    this.printbtn = false;
  }

  preview() {
    // this.selectStyle = 'as';
    this.previwbtn = false;
    this.printbtn = true;
    this.getSchoolDetailsForRC(this.studentId);
  }

  // private getClassSection() {
  //   this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
  //     response => {
  //       this.studentData = response;
  //       let mappedData: any = response;
  //       mappedData.forEach(standard => {
  //         standard['Sections'].forEach(section => {
  //           section['StdId'] = standard['standardId'];
  //           section['StdName'] = standard['standardsName'];
  //           section['selected'] = false;
  //           // console.log(section)
  //         });
  //         // console.log(standard)
  //       });
  //       this.studentData = mappedData;
  //       console.log(this.studentData)
  //       // this.get_userdetailes();
  //     },
  //     error => {
  //     });
  // };

  private getClassSection() {
    this.dataAnalyticsService
      .getClassSectionMap()
      .finally(() => {})
      .subscribe(
        (response) => {
          let mappedData: any = response;
          mappedData.forEach((standard) => {
            standard["Sections"].forEach((section) => {
              section["StdId"] = standard["standardId"];
              section["StdName"] = standard["standardsName"];
              section["selected"] = false;
            });
          });
          mappedData.sort((a, b) =>
            ("" + a.standardsName).localeCompare(b.standardsName, undefined, {
              numeric: true,
            })
          );
          if (this.adminUserFlag) {
            this.mappedData = mappedData;
            // this.priorityFlag = true;
          } else {
            this.mappedData = mappedData;
            this.get_userdetailes();
          }
        },
        (error) => {}
      );
  }

  private getAveragePerformances(SectionId, TestId, ChildId, YearId) {
    this.dataAnalyticsService
      .GetAveragePerformances(SectionId, TestId, ChildId, YearId)
      ._finally(() => {})
      .subscribe((response) => {
        this.Averages = response;
        console.log(this.Averages);
      });
  }

  private getStudentRecord(StudentId, TestId, yearId) {
    this.childMapId = [];
    this.loading = "block";
    this.dataAnalyticsService
      .getStudentRC(StudentId, TestId, yearId)
      ._finally(() => {
        this.loading = "none";
      })
      .subscribe((response) => {
        // console.log('studentRC', response)
        this.isEditable = true;
        this.studentRCData = response[0];
        this.studentRCData.studentRCInnerModels.sort((a, b) =>
          ("" + a.Subject).localeCompare(b.Subject, undefined, {
            numeric: true,
          })
        );
        console.log("studentRC", this.studentRCData);
        this.calculatePercentagesOnTheFly();
      });
  }

  calculatePercentagesOnTheFly() {
    this.HigherEdDRC.forEach((element) => {
      let subsubjectPercentage = [];
      for (let i = 0; i < element.SubSubjectMaxMarks.length; i++) {
        if (
          isNaN(element.SubSubjectsMarks[i]) ||
          element.SubSubjectsMarks[i] < 0 ||
          element.SubSubjectsMarks[i] > element.SubSubjectMaxMarks[i]
        ) {
          element.SubSubjectsMarks[i] = 0;
        }
        let percentage;
        if (element.SubSubjectAbsent[i] == 1) {
          percentage = 0;
        } else {
          percentage =
            (element.SubSubjectsMarks[i] / element.SubSubjectMaxMarks[i]) * 100;
        }
        subsubjectPercentage.push(percentage.toFixed(2));
      }
      element.subsubjectPercentage = subsubjectPercentage;
      element.Percentage = this.calculateSubjectPercentage(
        element.SubSubjectsMarks,
        element.SubSubjectMaxMarks,
        element.SubSubjectWeight,
        element.SubSubjectAbsent
      );
      element.Marks = this.calculateSubjectPercentage(
        element.SubSubjectsMarks,
        element.SubSubjectMaxMarks,
        element.SubSubjectWeight,
        element.SubSubjectAbsent
      );
      element.MaxMarks = 100;
    });
    console.log("calculatePercentagesOnTheFly", this.studentRCData);
  }

  private calculateSubjectPercentage(subMarks, maxMarks, weight, absent) {
    let subPercentage = subMarks.map((marks, index) => {
      if (absent[index] == 1) {
        return 0;
      } else {
        return (marks / maxMarks[index]) * 100;
      }
    });

    let totalWeight = weight.reduce((a, b) => a + b, 0);
    let subjectMarks = subPercentage.reduce((acc, curr, index) => {
      return acc + curr * weight[index];
    }, 0);

    return (subjectMarks / totalWeight).toFixed();
  }

  getSectionByGrade(grade) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.studentData.standardId = grade.standardId;
    this.standardId = grade.standardId;
    this.selectedSection = [];
    this.nameofstudent = [];
    this.nameofstd = grade.standardsName;
    this.sectionList = grade.Sections;
  }

  getGclClassesListById(section) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.nameofstudent = [];
    this.getStudentData(this.standardId, section.SectionId, this.yearId);
    console.log("sectionList1", section.sectionName);
  }
  // (minutes >= 1 && minutes <= 15)

  getColor(Percentage) {
    switch (true) {
      case Percentage >= 0 && Percentage <= 49:
        return "red";
      case Percentage >= 50 && Percentage <= 75:
        return "orange";
      case Percentage >= 76 && Percentage <= 100:
        return " #39FF14";
      // case Percentage >= 85 && Percentage <= 100:
      //   return 'skyblue';
    }
  }

  getRedColor(IsAbsent) {
    switch (true) {
      case IsAbsent == 1:
        return "red";
    }
  }

  public postScore() {
    // this.percentage();
    this.valid();
    // this.isEditable = true;
    let payload: any = {};
    //payload.OverallComments = this.studentRCData.OverallComments;
    payload.OverallComments = this.OverallComments;
    payload.testid = this.selectedExam;
    payload.childid = this.selectedinfo;
    payload.userid = this.userId;
    payload.courseid = this.selectedCourse;
    payload.batchid = this.selectedBatch;

    payload.AcademicYearId = this.yearId;
    //this.rcimodel.OverallPosition=this.studentRCData.OverallPosition
    //this.rcimodel.studentsRCModels =this.studentRCData.studentRCInnerModels
    this.calculatePercentagesOnTheFly();
    var rc = [];
    this.HigherEdDRC.forEach((element) => {
      let subject: any = {};
      subject.ChildExamSubjectMarksId = element.ChildCourseExamMarksId;
      subject.SubjectTestMappingId = element.SubjectExamMappingId;
      subject.SubjectID = element.SubjectId;
      subject.Marks = Number(element.Marks);
      subject.Percentage = Number(element.Marks);
      subject.Comments = element.Comments;
      subject.SubjectSemesterPercentage = Number(element.Marks);
      subject.SubSubjectsIds = element.SubSubjectsIds;

      subject.Percentage = Number(element.Marks);
      subject.SubSubjectsMarks = element.SubSubjectsMarks.map((val) => Number(val));
      subject.SubSubjectComment = element.SubSubjectComment;
      subject.SubAbsent = element.SubSubjectAbsent.map((val) => (val ? 1 : 0));
      subject.SubSubjectComment = Array.from({ length: element.SubSubjectsIds.length }, () => "");
      rc.push(subject);

      /*subject.ChildTestMappingId = element.ChildTestMappingId;
      subject.SubjectTestMappingId = element.SubjectTestMappingId;
      subject.Marks = Number(element.Marks);
      subject.Percentage = Number(element.Marks);
      subject.Comments = element.Comments;
      subject.SubjectSemesterPercentage = Number(element.Marks);
      subject.SubSubjectsIds = element.SubSubjectsIds;
      subject.SubSubjectsMarks = element.SubSubjectsMarks.map((val) =>
        Number(val)
      );
      subject.SubAbsent = element.SubSubjectAbsent.map((val) => (val ? 1 : 0));
      rc.push(subject);*/
    });
    payload.studentsHiEduRCModels = rc;

    console.log("postScoreHiEd", payload);
    this.dataAnalyticsService
      .postScoreHiEd(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          console.log(response);
          this.isEditable = true;
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Score/Comments Added Successfully",
          });
          this.GetStudentDRC();
          //this.getStudentRecord(this.studentId,this.testId,this.yearId);
          //this.getAveragePerformances(this.sectionId,this.testId,this.studentId,this.yearId);
        },
        (error) => {
          console.log(error);
          this.GetStudentDRC();
          // this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Marks has to be less than or equal to max marks' });
        }
      );
  }

  private getStudentData(StandardId, SectionId, AcademicYear) {
    this.dataAnalyticsService
      .getStudents(StandardId, SectionId, AcademicYear)
      ._finally(() => {})
      .subscribe((response) => {
        this.students = response["studentsList"];
        console.log(this.students);
        this.NumberOfStudents = response["No_of_Students"];
        // console.log(this.NumberOfStudents )
      });
  }

  getStudentListById(student) {
    this.studentRCData = [];
    this.SemesterData = [];
    this.TestData = [];
    this.nameofstudent = student.StudentName;
    this.studentId = student.StudentId;
    console.log(this.studentId);
    this.getSemesterData(this.yearId);
    // this.getStudentRecord(this.studentId);
  }

  getYearList(year) {
    console.log(year);
    this.mappedData = [];
    this.sectionList = [];
    this.students = [];
    this.NumberOfStudents = [];
    this.studentRCData = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentData = [];
    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;
    this.nameofstudent = [];
    this.getClassSection();
    console.log(this.yearname);
  }

  private getSemesterData(year) {
    this.dataAnalyticsService
      .getSemester(year)
      ._finally(() => {})
      .subscribe((response) => {
        this.SemesterData = response["semestersList"];
        console.log(this.SemesterData);
      });
  }

  private getYearData() {
    this.dataAnalyticsService
      .getYear()
      ._finally(() => {})
      .subscribe((response) => {
        this.YearData = response["yearList"];
        console.log(response);
      });
  }

  getSemesterListById(sem) {
    console.log(sem);
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsem = sem.SemesterName;
    this.getTestData(sem.SemesterId);
  }

  private getTestData(SemesterId) {
    this.dataAnalyticsService
      .getTest(SemesterId)
      ._finally(() => {})
      .subscribe((response) => {
        this.TestData = response["testsList"];
        console.log(this.TestData);
      });
  }

  getTestListById(test) {
    console.log(test);
    this.studentRCData = [];
    this.testId = test.TestId;
    this.nameoftest = test.TestName;
    this.getStudentRecord(this.studentId, this.testId, this.yearId);
    this.getAveragePerformances(
      this.sectionId,
      this.testId,
      this.studentId,
      this.yearId
    );
    // this.getSchoolDetailsForRC(this.studentId);
    console.log("ids", this.testId, this.studentId);
  }

  private getSchoolDetailsForRC(studentId) {
    this.dataAnalyticsService
      .getSchoolDetailsForRC(studentId, this.childMapId)
      ._finally(() => {})
      .subscribe((response) => {
        this.SchoolDetailsaddress = response;
        console.log(this.SchoolDetailsaddress);
        this.schoolName = this.SchoolDetailsaddress.SchoolName;
        this.Address = this.SchoolDetailsaddress.Address;
        this.City = this.SchoolDetailsaddress.City;
        this.Pincode = this.SchoolDetailsaddress.Pincode;
        this.PrimaryPhonenumber = this.SchoolDetailsaddress.PrimaryPhonenumber;
        this.WebsiteLink = this.SchoolDetailsaddress.WebsiteLink;
        this.Email = this.SchoolDetailsaddress.Email;
        this.Logo = this.SchoolDetailsaddress.Logo;
        this.RegNo = this.SchoolDetailsaddress.RegNo;
        // console.log(this.schoolName )
        // this.attachment = this.imgUrl1 + this.Logo;
        this.attachment = this.imgUrl1 + this.schoolLogo1;
        // this.EncodedLogo = 'data:image/jpg;base64,' + btoa(this.attachment)
        // console.log(this.attachment )
        this.SchoolDetailsaddress.Teachers.forEach((element) => {
          // element["TeacherName"] =element.TeacherName;
          this.TeacherNames = element.TeacherName;
          console.log(this.TeacherNames);
          // this.TeacherNames = this.TeacherNames.filter(a=> a.TeacherName == element.TeacherName)
        });
      });
  }

  // private percentage(){
  //   this.studentRCData.studentRCInnerModels.forEach(element => {
  //   element["Percentage"] = ((element.Marks / element.MaxMarks) * 100).toFixed(2);
  //     console.log(element)
  //   });
  //   console.log(this.studentRCData)
  // }

  private valid() {
    this.HigherEdDRC.forEach((element) => {
      if (element.Marks > element.MaxMarks) {
        this.messageService.add({
          severity: "error",
          summary: "Talkative Parents",
          detail: "Marks has to be less than or equal to max marks",
        });
      } else {
        // element["Percentage"] = ((element.Marks / element.MaxMarks) * 100).toFixed(2);
        element["Percentage"] =
          element.Marks != null && element.MaxMarks != null
            ? ((element.Marks / element.MaxMarks) * 100).toFixed(2)
            : null;
        element["SubjectSemesterPercentage"] = null;
      }
    });
    // this.RemovePercentage()
  }

  // private RemovePercentage(){
  //   this.studentRCData.studentRCInnerModels.forEach(element => {
  //     // console.log(element);
  //     if (element["Percentage"] == null){
  //         delete element.Percentage;
  //         delete element.Subject ;
  //         // // this.studentRCData.forEach(element1 => {
  //         // //   delete element1.childid;
  //         // // });
  //         // delete this.studentRCData.studentRCInnerModels.childid
  //        console.log(element);
  //     }
  //   });
  // }

  onCheckboxChange(event, index) {
    if (event.target.checked) {
      //this.studentRCData.studentRCInnerModels[index].Marks = 0
      //this.studentRCData.studentRCInnerModels[index].Comments = "ABSENT"
      //this.studentRCData.studentRCInnerModels[index].IsAbsent = true
    } else {
      //this.studentRCData.studentRCInnerModels[index].IsAbsent = false
      //this.studentRCData.studentRCInnerModels[index].Comments = null
    }
    this.calculatePercentagesOnTheFly();
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/Digital-report-card2Q/digital-report-card2Q.component.ts